<button style="float:right;" class="btn btn-primary" type="button" mdbBtn rounded="true" data-toggle="modal"
  data-target="#basicExample" (click)="frame.show()" mdbWavesEffect>
  {{ 'texto_60' | translate }}
</button>

<div mdbModal #frame="mdbModal" class="modal fade top" id="frameModalTop" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true">
  <div class="modal-dialog cascading-modal modal-avatar modal-sm" role="document">
    <div class="modal-content">
      <div class="modal-body mx-3" style="padding-right: 1rem; padding-left: 1rem;">
        <div class="card-header card-header-info">
          <h5 class="card-title mb-0">{{ 'texto_568' | translate }}</h5>
        </div>
        <button type="button" style="z-index:100;float: right;margin-top: -2.8rem;" class="btn btn-dark"
          data-dismiss="modal" (click)="frame.hide()" aria-label="Cerrar modal">X</button>

        <!-- ID -->
        <div class="md-form mb-3">
          <input type="text" id="soc-id" class="form-control" [formControl]="signupFormModalId" mdbInput mdbValidate>
          <label for="soc-id">ID. {{ 'texto_123' | translate }}</label>
          <mdb-error *ngIf="signupFormModalId.invalid && (signupFormModalId.dirty || signupFormModalId.touched)">
            {{ 'texto_61' | translate }}
          </mdb-error>
          <mdb-success *ngIf="signupFormModalId.valid && (signupFormModalId.dirty || signupFormModalId.touched)">
            {{ 'texto_62' | translate }}
          </mdb-success>
        </div>

        <!-- Nombre -->
        <div class="md-form mb-3">
          <input type="text" id="soc-name" class="form-control" [formControl]="signupFormModalName" mdbInput mdbValidate
            maxlength="255">
          <label for="soc-name">{{ 'texto_567' | translate }}</label>
          <mdb-error *ngIf="signupFormModalName.invalid && (signupFormModalName.dirty || signupFormModalName.touched)">
            {{ 'texto_61' | translate }}
          </mdb-error>
          <mdb-success *ngIf="signupFormModalName.valid && (signupFormModalName.dirty || signupFormModalName.touched)">
            {{ 'texto_62' | translate }}
          </mdb-success>
        </div>

        <!-- Web -->
        <div class="md-form mb-3">
          <input type="text" id="soc-web" class="form-control" [formControl]="signupFormModalWeb" mdbInput mdbValidate
            maxlength="255">
          <label for="soc-web">{{ 'texto_566' | translate }}</label>
          <mdb-error *ngIf="signupFormModalWeb.invalid && (signupFormModalWeb.dirty || signupFormModalWeb.touched)">
            {{ 'texto_61' | translate }}
          </mdb-error>
          <mdb-success *ngIf="signupFormModalWeb.valid && (signupFormModalWeb.dirty || signupFormModalWeb.touched)">
            {{ 'texto_62' | translate }}
          </mdb-success>
        </div>

        <!-- Comentario -->
        <div class="md-form">
          <label for="soc-comment">{{ 'texto_46' | translate }}</label>
          <mdb-icon fas icon="pencil-alt" class="prefix grey-text" style="margin-top: 15%;"></mdb-icon>
          <textarea id="soc-comment" maxlength="4000" rows="5" class="md-textarea form-control" mdbInput
            [formControl]="contactFormModalMessage"></textarea>
          <mdb-error
            *ngIf="contactFormModalMessage.invalid && (contactFormModalMessage.dirty || contactFormModalMessage.touched)">
            {{ 'texto_61' | translate }}
          </mdb-error>
          <mdb-success
            *ngIf="contactFormModalMessage.valid && (contactFormModalMessage.dirty || contactFormModalMessage.touched)">
            {{ 'texto_62' | translate }}
          </mdb-success>
        </div>
      </div>

      <div class="text-center mt-3">
        <button (click)="addSociedad()" mdbBtn rounded="true" class="btn-primary mt-1 waves-light" mdbWavesEffect>
          {{ 'texto_60' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
